/**
 * IrisService — global singleton to open the Iris floating panel from anywhere.
 * Mirrors the same pattern as toastService / confirmDialogService.
 *
 * Usage:
 *   // Register once in CreativeNodeFlow:
 *   irisService.register(() => { setIrisOpen(true); setIrisMinimized(false); });
 *
 *   // Call from any component:
 *   irisService.open();
 */

class IrisService {
  private _openHandler: (() => void) | null = null;

  /** Called once by CreativeNodeFlow to register the open handler. */
  register(handler: () => void) {
    this._openHandler = handler;
  }

  /** Opens (or restores if minimized) the Iris floating panel. */
  open() {
    this._openHandler?.();
  }
}

export const irisService = new IrisService();
export default irisService;
